import React from "react";

import styles from "../styles.module.scss";
import { LinkCustom } from "../../../../../components/navigation/LinkCustom/LinkCustom";

const IframeMenu = ({ isOpen, menuItems, menuPosition }) => {
    if(!isOpen || !menuItems) {
        return null;
    }

    const menuWrapperStyles = {
        position: "absolute",
        left: menuPosition?.left || 0,
        top: menuPosition?.top || 0
    };

    return (
        <div
            className={styles.menuWrapper}
            style={menuWrapperStyles}
        >
            <ul className={styles.menu}>
                {menuItems.map((props, i) => (
                    <li key={i}>
                        <LinkCustom
                            className={styles.linkCustom}
                            {...props}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default IframeMenu;
